export default __webpack_public_path__ + "static/media/erythree_carte_5-min.b387399f.png";